import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["styles"];

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from "react";
export default (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === void 0 ? {} : _ref$styles,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 21.1144h-4.2833v-6.9011c0-1.7322-.6256-2.9166-2.1745-2.9166-1.1855 0-1.8889.7944-2.2011 1.5622-.1044.2867-.1433.6644-.1433 1.0544v7.2011H8.91444c.05223-11.69329 0-12.90329 0-12.90329h4.28336v1.83669c.5644-.88447 1.5822-2.13669 3.8678-2.13669C19.8911 7.91111 22 9.76 22 13.7189v7.3955zM4.39556 6.45333H4.37c-1.44556 0-2.37-.99-2.37-2.22666C2 2.96333 2.96333 2 4.42222 2c1.47111 0 2.38222.96333 2.39556 2.22667.01333 1.23666-.92445 2.22666-2.42222 2.22666zM2.24778 21.1144h4.29666V8.21111H2.24778V21.1144z",
    fill: "currentColor"
  }));
});